import { createFileRoute } from "@tanstack/react-router";
import { useFlags } from "launchdarkly-react-client-sdk";

import Error404 from "@/components/pages/Error404";
import Onboarding1 from "@/features/onboarding/Onboarding1";
import BasicLayout from "@/layouts/Basic";

function Onboarding1Route() {
  const flags = useFlags();
  // eslint-disable-next-line ts/no-unsafe-assignment
  const showOldSignUp = flags["pd-show-old-sign-up-flow"];

  // eslint-disable-next-line ts/strict-boolean-expressions
  if (!showOldSignUp) {
    return (
      <BasicLayout>
        <Error404 />
      </BasicLayout>
    );
  }

  return (
    <BasicLayout>
      <Onboarding1 />
    </BasicLayout>
  );
}

export const Route = createFileRoute("/_auth-basic/onboarding-1")({
  component: Onboarding1Route,
});
